import { defineRule } from 'vee-validate';

export function registerValidationRules() {
    defineRule('required', value => {
        if (value === undefined || value === null || value === '') {
            return 'This field is required';
        }
        return true;
    });

    defineRule('shortRequired', value => {
        if (!value) {
            return 'Required';
        }
        return true;
    });

    defineRule('requiredTrimmed', (value) => {
        if (value == null || value.trim() === '') {
            return 'This field is required';
        }

        return true;
    });

    defineRule('number', value => {
        if (value === undefined || value === null || value === '') {
            return true; // let "required" handle empties
        }

        // Check if it's a valid number
        if (isNaN(value)) {
            return 'Enter Number';
        }

        return true;
    });


    defineRule('length', (value, [length]) => {
        // The field is empty so it should pass
        if (!value) {
            return true;
        }
        if (value.length > length) {
            return `This field must be ${length} or less characters`;
        }
        return true;
    });

    defineRule('min-length', (value, [length]) => {
        // The field is empty so it should pass
        if (!value || !value.length) {
            return true;
        }
        if (value.length < length) {
            return `This field must be ${length} or more characters`;
        }
        return true;
    });

    defineRule('min-value', (value, [min]) => {
        if (value === '' || value === null) return true; // let "required" handle empty
        return Number(value) >= min || `Must be at least ${min}`;
    });

    defineRule('exact-length', (value, [length]) => {
        // The field is empty so it should pass
        if (!value || !value.length) {
            return true;
        }
        if (value.length !== Number(length)) {
            return `This field must be ${length} characters`;
        }
        return true;
    })

    defineRule('email', value => {
        // Field is empty, should pass
        if (!value || !value.length) {
            return true;
        }

        // JavaScript code for email validation
        // without using regular expression
        var atSymbol = value.indexOf("@");
        var dotSymbol = value.lastIndexOf(".");
        var spaceSymbol = value.indexOf(" ");

        if ((atSymbol !== -1) &&
            (atSymbol !== 0) &&
            (dotSymbol !== -1) &&
            (dotSymbol !== 0) &&
            (dotSymbol > atSymbol + 1) &&
            (value.length > dotSymbol + 1) &&
            (spaceSymbol === -1)) {
            // alert("Email address is valid.");
            return true;
        } else {
            return 'This field must be a valid email';
        }

        // return true;
    });

    defineRule('email_list', value => {
        // Field is empty, should pass (required handles this separately)
        if (!value || !value.length) {
            return true;
        }

        const emails = value.split(',').map(email => email.trim());

        // Check each email address
        for (const email of emails) {

            // Reject empty entries
            if (!email.length) {
                return 'Please enter a valid email address for each entry';
            }

            const atSymbol = email.indexOf("@");
            const dotSymbol = email.lastIndexOf(".");
            const spaceSymbol = email.indexOf(" ");

            if (
                atSymbol === -1 ||
                atSymbol === 0 ||
                dotSymbol === -1 ||
                dotSymbol === 0 ||
                dotSymbol <= atSymbol + 1 ||
                email.length <= dotSymbol + 1 ||
                spaceSymbol !== -1
            ) {
                return `Invalid email address: ${email}`;
            }
        }

        return true;
    });

    defineRule('confirmed', (value, [target], ctx) => {
        if (value === ctx.form[target]) {
            return true;
        }
        return 'Passwords must match';
    });

    defineRule('phone', value => {
        // Field is empty, should pass
        if (!value || !value.length) {
            return true;
        }
        // Check if phone
        if (!/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,8}$/i.test(value)) {
            return 'This field must be a valid phone number';
        }
        return true;
    });
}
